{
  "fr": {
    "task": {
      "actions": {
        "create": "Tâche",
        "update": "Modifier la tâche"
      },
      "attributes": {
        "assignments_count": "Assignations",
        "category": "Catégorie",
        "created_at": "Créé le",
        "description": "Description",
        "title": "Titre",
        "units": "Unités"
      },
      "categories": {
        "confirmation": "Confirmation",
        "upload": "Téléversement"
      },
      "labels": {
        "no_tasks": "Aucune tâche pour ce projet pour le moment.",
        "required": "Ce champ est obligatoire",
        "units_required": "Sélectionnez au moins une unité"
      },
      "toasts": {
        "create": "Tâche créée",
        "delete": "Tâche supprimée",
        "update": "Tâche mise à jour"
      }
    }
  }
}
